<template>
  <div class="modal is-active">
    <div
      class="modal-background"
      @click.stop="$emit('close-audit-data-popup')"
    ></div>
    <div class="modal-content section-data" ref="view-container">
      <div class="title">
        View Audit Data -
        {{ audit.planId.internalId || audit.planId.ehcpId }}
      </div>
      <div class="subtitle">Select a theme to view audit details</div>
      <div class="subtitle">
        Overall Grading -
        <span
          class="grade-badge"
          :class="`grade-badge--${overallGrading.toLowerCase() || 'no-grade'}`"
        >
          {{ overallGrading }}</span
        >
      </div>
      <div v-for="(section, index) in orderedSections" :key="index">
        <div class="section-block-button" @click="viewSectionCriteria(section)">
          <div>{{ section.name }}</div>
          <div class="section-block-button__end">
            <div
              class="grade-badge"
              :class="`grade-badge--${section.determination || 'no-grade'}`"
            >
              {{
                section.id === 'additional-components'
                  ? `${section.criteria.optional.length} / 3 included`
                  : section.id === 'next-steps'
                  ? `${section.criteria.optional.length} actions`
                  : section.determination
              }}
            </div>
            <i class="fa fa-chevron-right"></i>
          </div>
        </div>
      </div>
      <div class="section-details" v-if="selectedCriteria">
        <div class="section-details__header">
          <p>
            <strong>{{ selectedCriteria.name }}</strong>
          </p>
          <i
            class="fa fa-close"
            @click="
              selectedCriteria = null
              $refs['view-container'].style.width = '420px'
            "
          ></i>
        </div>

        <div class="label">Comments:</div>
        <p class="section-details__comments">
          <i>{{ selectedCriteria.comments || 'No comments were added.' }}</i>
        </p>
        <ul
          v-for="grade in Object.keys(selectedCriteria.criteria).filter(
            c => selectedCriteria.criteria[c].length
          )"
          :key="grade"
        >
          <span class="underline">
            {{
              selectedCriteria.id === 'next-steps' ? 'Actionable items' : grade
            }}
          </span>
          <li
            v-for="(criteria, index) in selectedCriteria.criteria[grade]"
            :key="index"
          >
            <span v-if="selectedCriteria.id === 'next-steps'"
              >{{ index + 1 }}) </span
            >{{ criteria }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { gradableSections } from '@/utils/audit'

export default {
  name: 'ViewAuditDataPopup',
  props: ['audit'],
  data() {
    return {
      showAuditData: false,
      selectedCriteria: null
    }
  },
  computed: {
    orderedSections() {
      const order = [...gradableSections, 'additional-components', 'next-steps']
      return [...this.audit.sections].sort(
        (a, b) => order.indexOf(a.id) - order.indexOf(b.id)
      )
    },
    overallGrading() {
      return this.audit.assignmentId.outcome.toUpperCase()
    }
  },
  methods: {
    viewSectionCriteria(section) {
      this.$refs['view-container'].style.width = '650px'
      this.selectedCriteria = section
      this.selectedCriteria.totalCriteria = Object.keys(
        section.criteria
      ).reduce(
        (accum, current) => (accum += section.criteria[current].length),
        0
      )
    }
  },
  mounted() {
    this.selectedCriteria = null
    this.$refs['view-container'].style.width = '420px'
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/modal.scss';
@import '@/style/variables.scss';

.title {
  font-size: 20px;
  font-weight: bolder;
}

.subtitle {
  margin-bottom: 16px;
}

.grade-badge {
  color: white;
  border-radius: 4px;
  padding: 4px;
  font-size: 12px;
  font-weight: bolder;
  text-transform: capitalize;
  text-align: center;

  &--outstanding {
    background: $outstanding-color;
  }

  &--good {
    background: $good-color;
  }
  &--requires_improvement {
    background: $ri-color;
  }

  &--inadequate {
    background: $inadequate-color;
  }

  &--not_applicable {
    background: $na-color;
  }

  &--no-grade {
    background: grey;
  }
}

.section-block-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border: 1px solid lightgrey;
  border-radius: 8px;
  width: 100%;
  margin-bottom: 8px;
  padding: 8px;

  i {
    color: lightgrey;
  }

  &:hover {
    border: 1px solid rgba($brand-secondary, 0.2);
    background-color: rgba($brand-secondary, 0.2);
    font-weight: bolder;
    cursor: pointer;

    i {
      color: grey;
    }
  }

  &__end {
    display: flex;
    gap: 12px;
    align-items: center;
  }
}

.section-details {
  position: absolute;
  bottom: 0px;
  top: 52px;
  left: 0px;
  background: $background-color;
  border-top: 1px solid lightgrey;
  width: 100%;
  padding: 16px;

  &__comments {
    font-size: 0.9rem;
    text-align: left;
    border-radius: 8px;
    background-color: white;
    border: 1px solid grey;
    padding: 8px;
    margin-bottom: 16px;
  }

  ul {
    list-style: none;
    padding-inline-start: 0;
    span {
      font-size: 1rem;
      text-transform: capitalize;
    }
    li {
      font-size: 0.875rem;
      padding: 0.5rem 0;
    }
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-content: center;

    i {
      color: grey;
      cursor: pointer;
      &:hover {
        color: black;
      }
    }
  }
}

.label {
  margin-bottom: 4px;
  margin-top: 16px;
}

.underline {
  text-decoration: underline;
}
</style>
